import React, { useReducer } from "react";
//import { Redirect } from 'react-router-dom';
import axios from "axios";
import AuthContext from "./authContext";
import authReducer from "./authReducer";
import setAuthToken from "../../utils/setAuthToken";

import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  USER_LOADED,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  CLEAR_ERRORS,
  NOT_AUTHORIZED
} from "../types";

axios.defaults.baseURL =
  process.env.NODE_ENV === "production"
    ? "https://phonehome.cfbs-us.com:444/"
    : "http://localhost:5000/";

const AuthState = props => {
  const initialState = {
    token: localStorage.getItem("token"),
    isAuthenticated: null,
    loading: true,
    user: null,
    error: null
  };

  const [state, dispatch] = useReducer(authReducer, initialState);

  //Load User
  const loadUser = async () => {
    if (localStorage.token) {
      setAuthToken(localStorage.getItem("token"));

      // load token into global headers
      try {
        const res = await axios.get("api/v1/auth/me");
        //console.log('role', res.data.data.role);
        if (["admin", "user"].indexOf(res.data.data.role) !== -1) {
          dispatch({
            type: USER_LOADED,
            payload: res.data
          });
        } else {
          console.log("Not Authorized");
          dispatch({
            type: NOT_AUTHORIZED,
            payload: res.data
          });
        }
      } catch (err) {
        dispatch({
          type: AUTH_ERROR
        });
      }
    } else {
      dispatch({ type: LOGOUT });
    }
  };

  //Register User
  const register = async formData => {
    const config = {
      headers: { "Content-Type": "application/json" }
    };

    try {
      const res = await axios.post("/api/v1/users", formData, config);

      dispatch({ type: REGISTER_SUCCESS, payload: res.data });
      loadUser();
    } catch (err) {
      dispatch({ type: REGISTER_FAIL, payload: err.response.data.msg });
    }
  };

  //Login User
  const login = async formData => {
    const config = {
      headers: { "Content-Type": "application/json" }
    };

    try {
      const res = await axios.post("/api/v1/auth/login", formData, config);

      dispatch({ type: LOGIN_SUCCESS, payload: res.data });
      loadUser();
    } catch (err) {
      dispatch({ type: LOGIN_FAIL, payload: err.response.data.msg });
    }
  };

  //Logout User
  const logout = () => dispatch({ type: LOGOUT });

  //Clear Errors
  const clearErrors = () => dispatch({ type: CLEAR_ERRORS });

  return (
    <AuthContext.Provider
      value={{
        token: state.token,
        isAuthenticated: state.isAuthenticated,
        user: state.user,
        loading: state.loading,
        error: state.error,
        register,
        login,
        logout,
        clearErrors,
        loadUser
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthState;
